import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';
import type {
  CustomerProductMatch,
  ListCustomerProductMatchesQuery,
  ListCustomerProductMatchesResponse,
} from '@erp/rpc';

export function useCustomerProductMatches(
  filters: ListCustomerProductMatchesQuery = {
    limit: 25,
    offset: 0,
  },
) {
  const query = useQuery({
    ...orpc.accountsReceivable.customerProducts.list.queryOptions({
      input: filters,
    }),
    staleTime: 0, // Always fetch fresh data for audit view
  });

  const customerProductMatches = query.data?.customerProductMatches ?? [];
  const pagination = query.data?.pagination;

  return {
    ...query,
    customerProductMatches,
    pagination,
  } satisfies typeof query & {
    data?: ListCustomerProductMatchesResponse;
    customerProductMatches: CustomerProductMatch[];
    pagination: ListCustomerProductMatchesResponse['pagination'] | undefined;
  };
}
